const default12HourFormatter = (hour: number, minute: number): string => {
  const period = hour >= 12 ? 'pm' : 'am';
  const hour12 = hour % 12 || 12;
  return minute > 0 ? `${hour12}:${minute.toString().padStart(2, '0')}${period}` : `${hour12}${period}`;
};

/**
 * Takes a time string in 24-hour format and returns a 12-hour format.
 *
 * Default formatter for ante meridiem is to append AM and PM (e.g. 2 PM) with space between the hours and minutes
 */
export const convertTo12HourFormat = (time: string, formatter?: (hour: number, minutes: number) => string): string => {
  const timeFormatter = formatter ?? default12HourFormatter;
  const [hours, minutes] = time.split(':').map(Number);
  return timeFormatter(hours, minutes);
};

export const formatToReadableDate = (input: Date | { day: number; month: number; year: number }): string => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  let day: number;
  let month: number;
  let year: number;

  if (input instanceof Date) {
    day = input.getDate();
    month = input.getMonth() + 1; // getMonth() is zero-based, so add 1
    year = input.getFullYear();
  } else {
    ({ day, month, year } = input);
  }

  let suffix = 'th';
  if (day % 10 === 1 && day !== 11) {
    suffix = 'st';
  } else if (day % 10 === 2 && day !== 12) {
    suffix = 'nd';
  } else if (day % 10 === 3 && day !== 13) {
    suffix = 'rd';
  }

  return `${day}${suffix} ${months[month - 1]} ${year}`;
};
